/**
 * Aggressive Payment Methods Fix
 * This script patches the response at multiple levels to ensure transformation happens
 */
export default function applyPaymentMethodsFixAggressive() {
  console.log('🛡️ Loading Aggressive Payment Methods Fix...');
  
  // Helper to transform payment methods
  function transformPaymentMethods(data) {
    if (data && data.data && data.data.quickbooksGetCompanyPaymentMethods) {
      const result = data.data.quickbooksGetCompanyPaymentMethods;
      console.log('🛡️ [Aggressive Fix] Found payment methods response:', {
        hasData: !!result.data,
        hasResults: !!result.data && !!result.data.results,
        resultsIsArray: result.data && result.data.results && Array.isArray(result.data.results),
        hasRaw: !!result.data && !!result.data.raw,
        hasRawQueryResponse: !!result.data && !!result.data.raw && !!result.data.raw.QueryResponse
      });
      
      // PREFERRED: If we have the raw QuickBooks response, use that directly
      // Replace optional chaining with safe checks
      if (result.data && result.data.raw && result.data.raw.QueryResponse && result.data.raw.QueryResponse.PaymentMethod) {
        console.log('🛡️ [Aggressive Fix] Using raw QuickBooks response structure');
        const paymentMethods = result.data.raw.QueryResponse.PaymentMethod;
        const paymentMethodsArray = Array.isArray(paymentMethods) ? paymentMethods : [paymentMethods];
        
        // Transform to match frontend expectations: data.results.body.QueryResponse.PaymentMethod
        result.data.results = {
          body: {
            QueryResponse: {
              PaymentMethod: paymentMethodsArray
            }
          }
        };
        
        console.log('✅ [Aggressive Fix] Transformation complete from raw (count:', paymentMethodsArray.length, ')');
        return true;
      }
      // FALLBACK: If we have the simplified format (array), transform it to nested structure
      else if (result.data && result.data.results && Array.isArray(result.data.results)) {
        console.log('🔄 [Aggressive Fix] Transforming payment methods array to nested structure');
        
        const qbFormatPaymentMethods = result.data.results.map(pm => ({
          Id: pm.id,
          Name: pm.name,
          Type: pm.type,
          Active: pm.active,
          domain: 'QBO',
          sparse: false,
          SyncToken: '0'
        }));
        
        result.data.results = {
          body: {
            QueryResponse: {
              PaymentMethod: qbFormatPaymentMethods
            }
          }
        };
        
        console.log('✅ [Aggressive Fix] Transformation complete from array (count:', qbFormatPaymentMethods.length, ')');
        return true;
      } else {
        console.warn('⚠️ [Aggressive Fix] Payment methods response structure unexpected');
      }
    }
    return false;
  }
  
  // Patch fetch
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    const url = args[0];
    const options = args[1] || {};
    const isPaymentMethodsQuery = options.body && typeof options.body === 'string' && 
      options.body.includes('quickbooksGetCompanyPaymentMethods');
    
    return originalFetch.apply(this, args).then(response => {
      if (isPaymentMethodsQuery) {
        console.log('🛡️ [Aggressive Fix] Intercepted payment methods fetch request');
        
        // Patch .json() method
        const originalJson = response.json;
        response.json = function() {
          return originalJson.call(this).then(data => {
            transformPaymentMethods(data);
            return data;
          });
        };
        
        // Also patch .text() in case it's used
        const originalText = response.text;
        response.text = function() {
          return originalText.call(this).then(text => {
            try {
              const data = JSON.parse(text);
              if (transformPaymentMethods(data)) {
                return JSON.stringify(data);
              }
            } catch (e) {
              // Not JSON, return as-is
            }
            return text;
          });
        };
      }
      return response;
    });
  };
  
  // Patch XMLHttpRequest
  const originalXHROpen = XMLHttpRequest.prototype.open;
  const originalXHRSend = XMLHttpRequest.prototype.send;
  
  XMLHttpRequest.prototype.open = function(method, url, ...args) {
    this._url = url;
    this._method = method;
    return originalXHROpen.apply(this, [method, url, ...args]);
  };
  
  XMLHttpRequest.prototype.send = function(...args) {
    const xhr = this;
    const isPaymentMethodsQuery = xhr._url && xhr._url.includes('/graphql');
    
    const originalOnReadyStateChange = xhr.onreadystatechange;
    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4 && isPaymentMethodsQuery) {
        try {
          const text = xhr.responseText;
          if (text && text.includes('quickbooksGetCompanyPaymentMethods')) {
            console.log('🛡️ [Aggressive Fix] Intercepted payment methods XHR response');
            const data = JSON.parse(text);
            if (transformPaymentMethods(data)) {
              // Override responseText
              Object.defineProperty(xhr, 'responseText', {
                get: function() { return JSON.stringify(data); },
                configurable: true
              });
            }
          }
        } catch (e) {
          console.warn('🛡️ [Aggressive Fix] Error transforming XHR:', e);
        }
      }
      
      if (originalOnReadyStateChange) {
        originalOnReadyStateChange.apply(this, arguments);
      }
    };
    
    return originalXHRSend.apply(this, args);
  };
  
  console.log('✅ Aggressive Payment Methods Fix loaded');
}



// WEBPACK FOOTER //
// ./src/utils/patches/paymentMethodsFixAggressive.js